import service from '@/store/services/communauties/faqs-service';

const state = {
    list: [],
    faq: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, item) => {
        state.faq = item;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
};

const actions = {
    list({ commit, dispatch }, payload) {
        return service.list(payload)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((faq) => { commit('SET_RESOURCE', faq); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((faq) => { commit('SET_RESOURCE', faq); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((faq) => { commit('SET_RESOURCE', faq); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.total,
    faq: state => state.faq,
};

const faqs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default faqs;